import { nextTick, ref } from 'vue'
import { listShopProductSku, getShopProductDetail } from '@/apis/associated'
import { useRoute } from 'vue-router'
import { formatProduct } from './useShopProduct'

export const formatProductSku = (data: any) => {
  return (data || []).map((t: any) => ({
    ...t,
    id: t.shopItemSkuId,
    code: t.thirdSkuCode,
    name: t.thirdItemName,
    img: t.thirdSkuImage,
    PropertiesName: t.thirdItemAttribute,
    PriceJpy: t.thirdSalePrice ?? 0
  }))
}

export default (shopItemId: any, emits: any) => {
  const list: any = ref([])
  const loading: any = ref(false)
  const route = useRoute()
  const getList = () => {
    if (shopItemId.value) {
      loading.value = true
      emits('update:skuLoading', true)
      listShopProductSku({ shopItemId: shopItemId.value }).then(res => {
        list.value = formatProductSku(res.data)
        nextTick(() => {
          emits('update:skuList', list.value)
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
      return
    }
    if (route.query?.shopItemId) {
      loading.value = true
      emits('update:skuLoading', true)
      getShopProductDetail({ shopItemId: route.query.shopItemId }).then((res: any) => {
        if (res.data?.skuList) {
          res.data.skuList.forEach((v:any) => {
            v.thirdItemName = res.data.thirdItemName
          })
        }
        list.value = formatProductSku(res.data.skuList)
        nextTick(() => {
          console.log(res.data.skuList)
          emits('getData', formatProduct(res.data))
          emits('getSkuData', route.query.shopItemId)
          emits('update:skuList', list.value)
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
    }
  }

  return [
    loading,
    list,
    getList
  ]
}
